export default "__VITE_ASSET__BblK86VM__"